/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  DeleteApiV1PersonIdAttachmentsAttachmentidMutationResponse,
  DeleteApiV1PersonIdAttachmentsAttachmentidPathParams,
  DeleteApiV1PersonIdAttachmentsAttachmentid401,
  DeleteApiV1PersonIdAttachmentsAttachmentid404,
  DeleteApiV1PersonIdAttachmentsAttachmentid500,
} from "../../types/personDocumentsController/DeleteApiV1PersonIdAttachmentsAttachmentid.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { deleteApiV1PersonIdAttachmentsAttachmentid } from "../../clients/personDocumentsController/deleteApiV1PersonIdAttachmentsAttachmentid.ts";

export const deleteApiV1PersonIdAttachmentsAttachmentidMutationKey = () =>
  [{ url: "/api/v1/person/:id/attachments/:attachmentId" }] as const;

export type DeleteApiV1PersonIdAttachmentsAttachmentidMutationKey = ReturnType<
  typeof deleteApiV1PersonIdAttachmentsAttachmentidMutationKey
>;

export function deleteApiV1PersonIdAttachmentsAttachmentidMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey = deleteApiV1PersonIdAttachmentsAttachmentidMutationKey();
  return mutationOptions<
    DeleteApiV1PersonIdAttachmentsAttachmentidMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1PersonIdAttachmentsAttachmentid401
      | DeleteApiV1PersonIdAttachmentsAttachmentid404
      | DeleteApiV1PersonIdAttachmentsAttachmentid500
    >,
    {
      id: DeleteApiV1PersonIdAttachmentsAttachmentidPathParams["id"];
      attachmentId: DeleteApiV1PersonIdAttachmentsAttachmentidPathParams["attachmentId"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id, attachmentId }) => {
      return deleteApiV1PersonIdAttachmentsAttachmentid(
        id,
        attachmentId,
        config,
      );
    },
  });
}

/**
 * @description Soft delete (Active=false). O blob é apagado em best-effort. **(Requer Authorization para autenticação)**
 * @summary Excluir anexo (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/attachments/:attachmentId}
 */
export function useDeleteApiV1PersonIdAttachmentsAttachmentid<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiV1PersonIdAttachmentsAttachmentidMutationResponse,
      ResponseErrorConfig<
        | DeleteApiV1PersonIdAttachmentsAttachmentid401
        | DeleteApiV1PersonIdAttachmentsAttachmentid404
        | DeleteApiV1PersonIdAttachmentsAttachmentid500
      >,
      {
        id: DeleteApiV1PersonIdAttachmentsAttachmentidPathParams["id"];
        attachmentId: DeleteApiV1PersonIdAttachmentsAttachmentidPathParams["attachmentId"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    deleteApiV1PersonIdAttachmentsAttachmentidMutationKey();

  const baseOptions = deleteApiV1PersonIdAttachmentsAttachmentidMutationOptions(
    config,
  ) as UseMutationOptions<
    DeleteApiV1PersonIdAttachmentsAttachmentidMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1PersonIdAttachmentsAttachmentid401
      | DeleteApiV1PersonIdAttachmentsAttachmentid404
      | DeleteApiV1PersonIdAttachmentsAttachmentid500
    >,
    {
      id: DeleteApiV1PersonIdAttachmentsAttachmentidPathParams["id"];
      attachmentId: DeleteApiV1PersonIdAttachmentsAttachmentidPathParams["attachmentId"];
    },
    TContext
  >;

  return useMutation<
    DeleteApiV1PersonIdAttachmentsAttachmentidMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1PersonIdAttachmentsAttachmentid401
      | DeleteApiV1PersonIdAttachmentsAttachmentid404
      | DeleteApiV1PersonIdAttachmentsAttachmentid500
    >,
    {
      id: DeleteApiV1PersonIdAttachmentsAttachmentidPathParams["id"];
      attachmentId: DeleteApiV1PersonIdAttachmentsAttachmentidPathParams["attachmentId"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiV1PersonIdAttachmentsAttachmentidMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1PersonIdAttachmentsAttachmentid401
      | DeleteApiV1PersonIdAttachmentsAttachmentid404
      | DeleteApiV1PersonIdAttachmentsAttachmentid500
    >,
    {
      id: DeleteApiV1PersonIdAttachmentsAttachmentidPathParams["id"];
      attachmentId: DeleteApiV1PersonIdAttachmentsAttachmentidPathParams["attachmentId"];
    },
    TContext
  >;
}
